export default function AboutSection() {
  return (
    <section className="relative w-full py-16 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
        {/* Left: Info */}
        <div className="w-full lg:w-1/2">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-widest">
            About the Database
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 mb-6 leading-tight">
            What Is the <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed mb-8 max-w-xl">
            The Kakobuy Spreadsheet is an organized product discovery resource that helps shoppers quickly find products, compare categories, understand buying processes, and save time searching manually. Instead of scrolling through endless listings, you get a curated, structured database of the best finds — all in one place.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 border-t border-background-200 pt-8">
            <div>
              <span className="block font-heading text-3xl md:text-4xl font-extrabold text-accent-500">
                10K+
              </span>
              <span className="block text-sm text-foreground-500 mt-1 leading-snug">
                Product Entries
              </span>
            </div>
            <div>
              <span className="block font-heading text-3xl md:text-4xl font-extrabold text-accent-500">
                50+
              </span>
              <span className="block text-sm text-foreground-500 mt-1 leading-snug">
                Weekly Updates
              </span>
            </div>
            <div>
              <span className="block font-heading text-3xl md:text-4xl font-extrabold text-accent-500">
                14+
              </span>
              <span className="block text-sm text-foreground-500 mt-1 leading-snug">
                Categories
              </span>
            </div>
          </div>
        </div>

        {/* Right: Comparison Table */}
        <div className="w-full lg:w-1/2">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            <div className="px-5 py-4 border-b border-background-200/60">
              <h3 className="font-heading font-semibold text-foreground-900 text-base">
                Spreadsheet vs Traditional Search
              </h3>
            </div>
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-background-200/60 bg-background-100/50">
                  <th className="px-5 py-3 text-xs font-semibold text-foreground-600 uppercase tracking-wider">
                    Feature
                  </th>
                  <th className="px-5 py-3 text-xs font-semibold text-primary-600 uppercase tracking-wider">
                    Kakobuy Spreadsheet
                  </th>
                  <th className="px-5 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                    Traditional Search
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {[
                  { feature: 'Product Organization', spreadsheet: 'Excellent', traditional: 'Poor' },
                  { feature: 'Search Speed', spreadsheet: 'Fast', traditional: 'Slow' },
                  { feature: 'Category Filtering', spreadsheet: 'Available', traditional: 'Limited' },
                  { feature: 'Beginner Friendly', spreadsheet: 'Yes', traditional: 'No' },
                  { feature: 'QC Photo Access', spreadsheet: 'Included', traditional: 'Rare' },
                  { feature: 'Price Comparison', spreadsheet: 'Built-in', traditional: 'Manual' },
                ].map((row) => (
                  <tr key={row.feature} className="border-b border-background-200/40 hover:bg-background-100/30 transition-colors">
                    <td className="px-5 py-2.5 font-medium text-foreground-800 whitespace-nowrap">
                      {row.feature}
                    </td>
                    <td className="px-5 py-2.5 text-accent-600 font-semibold whitespace-nowrap">
                      <i className="ri-check-line mr-1"></i>{row.spreadsheet}
                    </td>
                    <td className="px-5 py-2.5 text-foreground-400 whitespace-nowrap">
                      {row.traditional}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}